import { render, staticRenderFns } from "./BlockViewer.vue?vue&type=template&id=2b95b37a"
import script from "./BlockViewer.vue?vue&type=script&lang=js"
export * from "./BlockViewer.vue?vue&type=script&lang=js"
import style0 from "./BlockViewer.vue?vue&type=style&index=0&id=2b95b37a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports